<template>
  <!--begin::Body-->
  <div class="card-body">
    <!--begin::Section-->
    <div class="d-flex align-items-center">
      <!--begin::Pic-->
      <div
        class="
          flex-shrink-0
          mr-4
          symbol symbol-65 symbol-circle
          bg-secondary
          p-4
        "
      >
        <b-img-lazy
          left
          :src="getImageUrl(eduProgram.icon_path)"
          center
          rounded="circle"
          style="width: 110px"
        />
      </div>
      <!--end::Pic-->

      <!--begin::Info-->
      <div class="d-flex flex-column mr-auto">
        <!--begin: Title-->
        <a
          class="
            card-title
            text-hover-primary
            font-size-h4
            mb-1
            card-body-title
          "
        >
          {{ eduProgram.name }}
        </a>
        <span class="mt-2 font-weight-bolder card-body-subtitle">
          {{ eduProgram.edu_season.name }} ـــ
          {{ eduProgram.program_list.name }}
        </span>
        <!--end::Title-->
      </div>
      <!--end::Info-->
    </div>
    <!--end::Section-->

    <div class="row">
      <div class="col-sm-9">
        <!--begin::Content-->
        <div class="d-flex flex-wrap mt-14">
          <div class="mr-12 d-flex flex-column mb-7">
            <span
              class="
                d-block
                font-weight-bolder font-size-md font-size-h6-xxl
                text-black-50
                mb-4
              "
            >
             {{ $t("edu_programs.end_date") }}
            </span>
            <span
              class="
                font-size-md font-size-h6-xxl font-weight-bolder
                btn-upper
                valid-color
              "
            >
              {{ eduProgram.g_study_start_date }}
            </span>
          </div>
          <div class="mr-12 d-flex flex-column mb-7">
            <span
              class="
                d-block
                font-weight-bolder font-size-md font-size-h6-xxl
                text-black-50
                mb-4
              "
            >
              {{ $t("edu_programs.end_date") }}
            </span>
            <span
              class="
                font-size-md font-size-h6-xxl font-weight-bolder
                btn-upper
                valid-color
              "
            >
              {{ eduProgram.g_study_end_date }}
            </span>
          </div>

          <!--begin::Progress-->
          <div class="mr-12 d-flex flex-column mb-7">
            <span
              class="
                d-block
                font-weight-bolder font-size-md font-size-h6-xxl
                mb-4
                text-black-50
              "
            >
              {{ $t("edu_programs.edu_program_completion_rate") }}
            </span>
            <div>
              <h2 class="pers text-primary font-weight-bolder font-size-h6">
                {{ eduProgram.completion_percentage + "%" }}
              </h2>
              <div>
                <b-progress
                  :value="eduProgram.completion_percentage"
                  :max="100"
                  show-progress
                  height="1rem"
                />
              </div>
            </div>
          </div>
          <!--end::Progress-->

          <div class="mr-12 d-flex flex-column mb-7">
            <span
              class="
                d-block
                font-weight-bolder font-size-md font-size-h6-xxl
                text-black-50
                mb-4
              "
            >
              {{ $t("edu_programs.num_of_years") }}
            </span>
            <div class="text-center">
              <span
                class="
                  font-size-md font-weight-bolder
                  valid-color
                  badge-warning badge
                  rounded-pill
                  px-4
                "
              >
                {{ eduProgram.num_of_years }}
              </span>
            </div>
          </div>
        </div>
        <!--end::Content-->

        <!--begin::Blog-->
        <div class="row justify-content-between">
          <div class="d-flex flex-wrap align-items-center">
            <div class="mr-5 d-flex flex-column mb-3 pt-4">
              <span
                class="font-weight-bold mb-4 text-muted font-size-md gs-m"
              >{{ $t("edu_programs.session_type") }}</span>
            </div>

            <!--begin: Item-->
            <div
              v-for="item in eduProgram.session_types"
              :key="item.id"
              class="mr-3 d-flex flex-column mb-3"
            >
              <button
                type="button"
                class="
                  font-size-xs
                  btn btn-outline-secondary
                  px-5
                  py-2
                  rounded-pill
                  font-weight-bolder
                "
              >
                {{ $t(`edu_programs.${item.name}`) }}
              </button>
            </div>
          </div>
          <!-- /.d-flex-->
        </div>
        <!--end::Blog-->
      </div>

      <div
        class="
          col-sm-3
          d-flex
          align-items-center align-items-sm-end
          justify-content-end
          flex-column
        "
      >
        <slot>
          <div class="text-center">
            <a
              class="btn btn-primary py-7 px-11 rounded mt-4 ges-m font-size-lg"
              :href="'#/page/edu_programs/'+eduProgram.id"
            >
              {{ $t("site.show") }}
            </a>
          </div>
        </slot>
      </div>
    </div>
    <!-- /.row -->
  </div>
  <!-- /.card-body -->
</template>

<script>
import config from '../../../../config/config'

export default {
  props: ['eduProgram'],
  methods: {
    getImageUrl(image_path) {
      return config.serverUrl + image_path
    },
  },
}
</script>

<style>
</style>
